import { render } from "./HowItWorks.vue?vue&type=template&id=7a1682a0&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=7a1682a0&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1682a0"]])

export default __exports__